import lib from "zeta-dom";
const { InheritedNodeTree } = lib;
export { InheritedNodeTree };